import { defineStore } from 'pinia';
import { reactive, ref } from 'vue';
import { useAtomicSetter } from '@/composables/useAtomicSetter.js';

const useAgencyUserStore = defineStore('agency-users', () => {
  const filters = reactive({
    page: 1,
    per_page: 25,
  });

  const shouldResetFilters = ref(true);

  const stateRefs = {
    shouldResetFilters,
  };

  const { setAtomic } = useAtomicSetter(stateRefs);

  const setFilters = (newFilters) => {
    Object.assign(filters, newFilters);
  };

  const resetFilters = () => {
    Object.assign(filters, { page: 1 });
  };

  return { filters, setFilters, resetFilters, ...stateRefs, setAtomic };
});

export { useAgencyUserStore };
